import { IErrorReason } from '../interfaces/IConfig';

export const addGroupsToReasons = (errorReasons: IErrorReason[]) => {
    // this function groups error reasons by errorGroup
    // each error group is then transformed in an additional
    // (disabled) select option in order to emulate <optgroup>
    let _map = new Map();
    let reasons: IErrorReason[] = [];
    errorReasons.forEach((reason) => {
        if (_map.has(reason.errorGroup)) {
            _map.get(reason.errorGroup).push(reason);
        } else {
            _map.set(reason.errorGroup, [reason]);
        }
    });
    _map.forEach((group_reasons, group) => {
        // group entry does not have an errorCode
        reasons.push({
            errorLabel: '',
            errorCode: '',
            errorGroup: group,
        });
        reasons = reasons.concat(group_reasons);
    });
    return reasons;
};
